import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { from } from 'rxjs';
import { FieldComponent } from '../field.component'
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatCheckboxClickAction } from '@angular/material/checkbox';

@Component({
  selector: 'app-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['./../Field-Styles.scss'],
})
export class CheckBoxFieldComponent extends FieldComponent implements OnInit {
  @Input() public showUpdateButt: Array<boolean> = [];
  @Input() public callBack: (data: any) => void;

  public CheckBoxUserVal: boolean;
  public SourchMismatch: boolean = false;

  constructor() {
    super();
  }

  ngOnInit() {
    this.CheckBoxUserVal = this.RealValue;
  }

  checkBoxChange(event : MatCheckboxChange) {
    this.CheckBoxUserVal = event.checked;

    if (this.CheckBoxUserVal != this.RealValue) {
      this.SourchMismatch = true;
      this.showUpdateButt.push(true);
    }
    else {
      this.SourchMismatch = false;
      this.showUpdateButt.pop();
    }

    if (this.callBack)
      this.callBack(event);
  }

  getValue() {
    if(!this.SourchMismatch)
      return undefined;
    return this.CheckBoxUserVal;
  }
}
